export default [
    // 部门管理
    {
        path: "department",
        name: "departmentManage",
        component: () => import(/* webpackChunkName: "aftersales" */ "@/views/department/departmentmanage/index"),
    },
    // 角色管理
    {
        path: "role",
        name: "roleManage",
        component: () => import(/* webpackChunkName: "aftersales" */ "@/views/department/rolemanage/index"),
    },
    // 角色管理
    {
        path: "role/update/:type",
        name: "roleManageDetail",
        component: () => import(/* webpackChunkName: "aftersales" */ "@/views/department/rolemanage/update"),
    },
]
